export default function RequiredSign() {
  return <span className="has-text-danger fw-bold text-is-16">*</span>;
}
